import type { SolutionType } from '@app/src/types/resourceExplorer'

export enum EntitlementFeature {
  Questionnaire = 'Questionnaire',
  Assessment = 'Assessment',
  AiScreening = 'AiScreening',
}

export enum EntitlementState {
  Active = 'Active',
  OffByAdmin = 'OffByAdmin',
  AvailableViaSales = 'AvailableViaSales',
  LimitReached = 'LimitReached',
  NotApplicable = 'NotApplicable',
  Unavailable = 'Unavailable',
}

export enum AccessPolicy {
  Included = 'Included',
  AddOn = 'AddOn',
  Hidden = 'Hidden',
}

export enum EntitlementEffect {
  Grant = 'Grant',
  Deny = 'Deny',
}

export enum EntitlementSource {
  Csm = 'Csm',
  MigratedFlag = 'MigratedFlag',
  MigratedAvailability = 'MigratedAvailability',
}

export interface AdminScopeAccess {
  feature: EntitlementFeature
  scopeId: number
  title: string
  questionnaireTemplateId?: number
  policy: AccessPolicy
  isDefaultScope: boolean
  isVisible: boolean
  state: EntitlementState
  isEntitled: boolean
  decidedByEntitlementId?: number
}

export interface OrganizationEntitlement {
  id: number
  solutionType?: SolutionType
  feature: EntitlementFeature
  scopeId?: number
  effect: EntitlementEffect
  source: EntitlementSource
  validFrom?: string
  validUntil?: string
  note?: string
  createdAt: string
  creatorUserId?: number
}

export interface OrganizationEntitlementOverview {
  scopes: AdminScopeAccess[]
  entitlements: OrganizationEntitlement[]
  allowedProviderScreenings?: number
  remainingProviderScreenings?: number
}

export interface EntitlementChange {
  feature: EntitlementFeature
  scopeId: number | null
  effect: EntitlementEffect | null
  note: string | null
  validUntil?: string | null
}

export interface EntitlementPolicy {
  feature: EntitlementFeature
  scopeId: number
  policy: AccessPolicy
  isDefaultScope: boolean
}

export type ScopeEntitlement = Pick<
  OrganizationEntitlement,
  'solutionType' | 'effect' | 'source' | 'validUntil' | 'note'
> & {
  organizationId: number
  organizationName: string
}
